import { FluxStandardAction as Action } from "flux-standard-action";
import { COLLECTIONS } from "constants/action-types";
import { ISchemaKey } from "helpers/product-collection";
import { SizeAllocationType } from "constants/product-collection";
import { IBagTable } from "helpers/table-bag";
import { BagValues } from "helpers/allocation-dimension";

export const copyDoorAllocation = (collectionId: string, door: string) => ({
    type: COLLECTIONS.COLLECTION.ALLOCATIONS.DOOR.COPY,
    payload: { collectionId, door },
});

export const pasteDoorAllocation = (itemsId: string, door: string, filterAssortmentByBrand: string) => ({
    type: COLLECTIONS.COLLECTION.ALLOCATIONS.DOOR.PASTE,
    payload: { itemsId, door, filterAssortmentByBrand },
});

export interface IAllocatePayload {
    collectionId: string;
    itemIds: string[];
    // List of allocation bag to constraint sizing. Index position correlates to index of `itemIds`
    constraintAllocations?: IBagTable[] | BagValues[];
    force?: boolean;
    merchantId: string;
    rawItemDisplayProperty: ISchemaKey[];
    allocationMethod?: SizeAllocationType;
    ignoreInfeasible?: boolean;
}

export const allocateStart = (payload: IAllocatePayload) => ({
    type: COLLECTIONS.COLLECTION.ALLOCATIONS.ALLOCATE.START,
    payload,
});

export const allocateStop = () => ({
    type: COLLECTIONS.COLLECTION.ALLOCATIONS.ALLOCATE.STOP,
});

interface ISyncBulkWithAllocationPayload {
    collectionId: string;
    rowId: string;
}
export type SyncBulkWithAllocationAction = Action<ISyncBulkWithAllocationPayload, undefined>;
export const syncBulkWithAllocation = (payload: ISyncBulkWithAllocationPayload): SyncBulkWithAllocationAction => ({
    type: COLLECTIONS.COLLECTION.ALLOCATIONS.SYNC_BULK_WITH_ALLOCATION,
    payload,
    meta: undefined,
});

export interface IClearAllocationsPayload {
    itemId: string;
}
export type ClearAllocationsAction = Action<IClearAllocationsPayload, {}>;
export const clearAllocations = (payload: IClearAllocationsPayload): ClearAllocationsAction => ({
    meta: {},
    payload,
    type: COLLECTIONS.COLLECTION.ALLOCATIONS.CLEAR,
});
